import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { definitionListDescription } from './definitionListDescription.vanilla.mjs';

const TooltipDefinitionListDescription = forwardRef(({ className: classNameFromProps, monospace, ...props }, forwardedRef) => {
  const className = classNames(
    definitionListDescription({ monospace }),
    classNameFromProps
  );
  return /* @__PURE__ */ jsx(
    "dd",
    {
      "data-scope": "tooltip",
      "data-part": "definition-list-description",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});
TooltipDefinitionListDescription.displayName = "Tooltip.DefinitionListDescription";

export { TooltipDefinitionListDescription };
//# sourceMappingURL=DefinitionListDescription.mjs.map
